export const HOME = '/';
export const ERROR = '*';
export const SERVICES = '/our-services';
export const APPOINTMENT = '/book-an-appointment';
export const DOCTORS = '/our-doctors';
export const JENYO = '/our-doctors/toyin-jenyo';
export const INSURANCE = '/insurance-partnership';
export const INFORMATION = '/information';

